import type { Profile } from '@/types';

export const profile: Profile = {
  fullName: 'Muhammad Sufyan Malik',
  shortName: 'Sufyan Malik',
  title: 'Software Team Lead building scalable web and mobile products',
  location: 'Çankaya, Ankara, Türkiye',
  email: 'muhammadsufyanmalik93@gmail.com',
  // CV also lists malikmsufyan@gmail.com — kept as secondary if you want it shown later.
  phonePrimary: '+90 553 695 7549',
  phoneSecondary: '+92 315 315 1468',
  githubUrl: 'https://github.com/MuhammadSufyanMalik',
  websiteUrl: 'https://muhammadsufyanmalik.com',
  resumePath: '/Muhammad_Sufyan_Malik.pdf',
  heroIntro:
    'Software Team Lead leading engineering delivery across backend, admin, and mobile workstreams—with experience across .NET backends, Angular web apps, and Flutter/Android/iOS clients, containerized with Docker and shipped through Azure DevOps CI/CD.',
  about: [
    'I am a Software Team Lead with a strong interest in mentoring and continuous learning. I now own architecture decisions and delivery across backend, admin, and mobile workstreams for a full-stack platform, while looking for growth-oriented teams where solid engineering and clear communication matter.',
    'My recent work centers on C# and .NET Core systems using layered architecture, repository patterns, CQRS, MediatR, messaging, SignalR, and Elasticsearch—alongside Angular frontends and mobile delivery with Flutter, Android, and SwiftUI.',
    'Based in Ankara, I bring experience from both web platform engineering and hands-on mobile product development, from analysis through testing, containerized deployment with Docker, multi-environment Azure DevOps CI/CD pipelines, and ongoing support.',
    'I actively bring AI-assisted tools into the development workflow—from AI-assisted coding to building internal AI/DevOps agents—to move faster without cutting corners on quality.',
  ],
  focusAreas: [
    'Backend and API development with C#, .NET Core, CQRS, and MediatR',
    'Full-stack web applications with Angular and related tooling',
    'Cross-platform mobile development with Flutter, Android, and SwiftUI',
    'Search, messaging, realtime, and Docker-based delivery (Elasticsearch, RabbitMQ, SignalR)',
    'Containerization and multi-environment CI/CD delivery with Docker and Azure DevOps',
    'AI-assisted engineering, including internal AI/DevOps tooling',
  ],
};
